var paragraph_default = {
  "fontElementMap": "_4fByZ",
  "elementSpacing": "_92a4z",
  "text": "wyQnS _92a4z",
  "child": "UfL7-"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
